module.exports = __webpack_public_path__ + "assets/images/mega-hybrid.7532bdf38020f3cf14c70fbe9b7065d4.png";